import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CollapsibleColumn from 'components/p5/CollapsibleColumn'
import { useFetchConsignmentSummary } from 'features/declaration/consignment/api/fetchConsignmentSummary'
import { useDeclarationEditorContext } from 'features/declaration/form/contexts/DeclarationEditorContext'

interface FieldProps {
  labelKey: string
}

function Field({ labelKey, children }: React.PropsWithChildren<FieldProps>) {
  const { t } = useTranslation()

  return (
    <div className="row mb-2">
      <div className="col-4 d-flex align-items-center justify-content-end text-end input-label pt-0">
        {t(labelKey)}
      </div>
      <div className="col-8">{children}</div>
    </div>
  )
}

interface CountryListItem {
  id: string
  code: string
}

function toCountryListItems(countriesWithCodePrefix: string[]): CountryListItem[] {
  return countriesWithCodePrefix.map((countryWithCodePrefix) => ({
    id: crypto.randomUUID(),
    code: countryWithCodePrefix.replace('COUNTRY_', ''),
  }))
}

function GeneralInformation({ consignmentId } : Readonly<{ consignmentId: number | null }>) {
  const { t } = useTranslation()

  const { editorData } = useDeclarationEditorContext()
  const { data: summary } = useFetchConsignmentSummary(consignmentId)
  const declarationType = editorData?.declarationType ?? ''
  const numberOfGoods = summary?.numberOfItems ?? 0
  const countries = useMemo(() => toCountryListItems(editorData?.countriesOfRouting ?? []), [editorData?.countriesOfRouting])

  return (
    <section className="py-3">
      <CollapsibleColumn
        columnId="declaration-general-information"
        headingLabel={t('declaration.p5.generalInformation')}
      >
        <div className="row">
          <div className="col-lg-6">
            <Field labelKey="declaration.p5.declarationType"><span>{declarationType}</span></Field>
            <Field labelKey="declaration.p5.customsOfficeOfRouting">
              {countries.map((item) => (
                <span className="me-2" key={`${item.id}`}>
                  {item.code}
                </span>
              ))}
            </Field>
          </div>
          <div className="col-lg-6">
            <Field labelKey="declaration.p5.numberOfItemsDeclaration">
              <span>{numberOfGoods}</span>
            </Field>
          </div>
        </div>
      </CollapsibleColumn>
    </section>
  )
}

export default GeneralInformation

